import MojitoCore from 'mojito/core';
import { STORE_KEY, INITIAL_STATE } from './slice.js';

const reduxInstance = MojitoCore.Services.redux;

/**
 * Top sports selectors.
 *
 * @class TopSportsSelectors
 * @name selectors
 * @memberof Mojito.Modules.TopSports
 */

/**
 * Selects top sports state.
 *
 * @function selectState
 *
 * @param {object} [state] - Redux state object. The application state from {@link Mojito.Core.Services.redux#getStore|global store} will be used if not provided.
 * @returns {Mojito.Modules.TopSports.TopSportsState} The state of the top sports.
 *
 * @memberof Mojito.Modules.TopSports.selectors
 */

export const selectState = state => {
    const appState = state || reduxInstance.store?.getState();
    return appState?.[STORE_KEY] || INITIAL_STATE;
};

/**
 * Select show all sports.
 *
 * @function selectTopSportLive
 *
 * @param {object} [state] - Redux state object. The application state from {@link Mojito.Core.Services.redux#getStore|global store} will be used if not provided.
 * @returns {string} Selected sport for in-play events.
 *
 * @memberof Mojito.Modules.TopSports.selectors
 */
export const selectTopSportLive = state => {
    return selectState(state).topSportLive;
};

/**
 * Select favorite sports.
 *
 * @function selectTopSportFeatured
 *
 * @param {object} [state] - Redux state object. The application state from {@link Mojito.Core.Services.redux#getStore|global store} will be used if not provided.
 * @returns {string} Selected sport for featured events.
 *
 * @memberof Mojito.Modules.TopSports.selectors
 */
export const selectTopSportFeatured = state => {
    return selectState(state).topSportFeatured;
};

/**
 * Select selected sport for live-and-future events.
 *
 * @function selectTopSportLiveAndFeatured
 *
 * @param {object} [state] - Redux state object. The application state from {@link Mojito.Core.Services.redux#getStore|global store} will be used if not provided.
 * @returns {string} Selected sport for live-and-future events.
 *
 * @memberof Mojito.Modules.TopSports.selectors
 */
export const selectTopSportLiveAndFeatured = state => {
    return selectState(state).topSportLiveAndFeatured;
};
